/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import { Button, ButtonToolbar, Col, Form } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { NoticeContentManagementSystem } from "../../../../../_metronic/_partials/controls";
import AppConfig from "../../../../config/AppConfig";
import Select from "react-select";

class ContentManagementSystem extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    sessiondata: JSON.parse(localStorage.getItem("sessiondata")),
    userdata: JSON.parse(localStorage.getItem("userdata")),
    loadingBtn: false,
    loadingForm: true,
    // ==================================
    errors: [],
    // FORM
    judul_konten: "",
    deskripsi: "",
    id_viewer: null,
    cover_pict: "",
    cover_pict_name: "Choose File",
    is_new_cover_pict: false,
    konten: "",
    files: "",
    file_name: "Choose File",
    is_new_file: false,
  };

  onInputForm = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };
  selectedRole = (val) => {
    this.setState({
      id_viewer: val.value,
    });
  };
  handleUploadCoverPict = (e) => {
    var files = e.target.files || e.dataTransfer.files;
    this.state.cover_pict = files[0];
    this.setState({ cover_pict_name: files[0].name, is_new_cover_pict: true });
  };
  handleUploadFiles = (e) => {
    var files = e.target.files || e.dataTransfer.files;
    this.state.files = files[0];
    this.setState({ file_name: files[0].name, is_new_file: true });
  };
  // handleUploadFiles = (e) => {
  //   var files = e.target.files || e.dataTransfer.files;
  //   this.state.files = files;
  //   let names = [];
  //   if (files.length > 0) {
  //     for (let i = 0; i < files.length; i++) {
  //       const name = files[i].name;
  //       names.push(name);
  //     }
  //     names = names.join(", ");
  //   }
  //   this.setState({
  //     file_name:
  //       files.length === 1 ? files[0].name : `${files.length} files (${names})`,
  //     is_new_file: true,
  //   });
  // };
  handleChange = (html) => {
    this.setState({ konten: html });
  };

  componentDidMount() {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

    if(sessiondata.i_idrole !== 10 && sessiondata.i_idrole !== 2014) {
       window.location.href = "/"; 
    }

    if (this.props.match.params.id === undefined) {
      const timer = setTimeout(
        () => this.setState({ loadingForm: false }),
        1000
      );
      return () => clearTimeout(timer);
    } else {
      axios
        .get(AppConfig.EditInformasi + this.props.match.params.id)
        .then((res) => {
          this.setState({
            loadingForm: false,
            judul_konten: res.data.result.data_konten.judul,
            deskripsi: res.data.result.data_konten.deskripsi,
            konten: res.data.result.data_konten.isi_konten,
            id_viewer:
              res.data.result.data_konten.id_viewer === "null"
                ? 0
                : res.data.result.data_konten.id_viewer,
            cover_pict_name:
              res.data.result.data_cover_pict.filename !== undefined
                ? res.data.result.data_cover_pict.filename
                : "Choose File",
            file_name:
              res.data.result.data_lampiran.filename !== undefined
                ? res.data.result.data_lampiran.filename
                : "Choose File",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  validateForm() {
    let errors = [];
    let formIsValid = true;

    if (!this.state.judul_konten) {
      formIsValid = false;
      errors["judul_konten"] = "Judul konten tidak boleh kosong.";
    }

    if (!this.state.deskripsi) {
      formIsValid = false;
      errors["deskripsi"] = "Deskripsi tidak boleh kosong.";
    }

    // if (!this.state.id_viewer) {
    //   formIsValid = false;
    //   errors["id_viewer"] = "Mohon pilih dimana informasi akan ditampilkan.";
    // }

    if (!this.state.konten) {
      formIsValid = false;
      errors["konten"] = "Konten tidak boleh kosong.";
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  // Submit User ============================================================================
  handleSave = (e) => {

    e.preventDefault();
    e.target.className += " was-validated";

    if (this.validateForm()) {
      this.setState({ loadingBtn: true });
      let session = "";
      if (this.state.userdata) {
        session =
          // "?token="+userdata.token+`
          "?id_updater=" +
          this.state.userdata.id_pengguna +
          "&id_role=" +
          this.state.sessiondata.i_idrole +
          "&nm_role=" +
          this.state.sessiondata.i_namarole +
          "&id_unit=" +
          this.state.sessiondata.i_idunit +
          "&nm_unit=" +
          this.state.sessiondata.i_nmunit;
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      var formData = new FormData();
      if (this.props.match.params.id !== undefined) {
        formData.append("data[id]", this.props.match.params.id);
      } else {
        formData.append("data[id]", "");
      }
      formData.append("data[judul_konten]", this.state.judul_konten);
      formData.append("data[konten]", this.state.konten);
      formData.append("data[deskripsi]", this.state.deskripsi);
      formData.append("data[id_viewer]", this.state.id_viewer);
      if (this.state.is_new_cover_pict === true) {
        formData.append("gambar_sampul", this.state.cover_pict);
      }
      if (this.state.is_new_file === true) {
        formData.append("lampiran", this.state.files);
      }
      axios
        .post(AppConfig.SaveInformasi + session, formData, config)
        .then((res) => {
          this.setState({
            loadingBtn: false,
          });
          if (res.data.status === "sukses") {
            swal({
              title: "Sukses!",
              text: res.data.message,
              icon: "success",
              button: "OK!",
            }).then(() => {
              window.history.back();
            });
          } else {
            swal({
              title: "Gagal!",
              text: res.data.message,
              icon: "error",
              button: "Tutup",
            });
          }
        })
        .catch((err) => {
          swal({
            title: "Gagal!",
            text: "Gagal menyimpan data!",
            icon: "error",
            button: "OK!",
          });
          console.log(err);
          this.setState({ loadingBtn: false });
        });
    }
  };

  // Layout ============================================================================
  render() {
    const roles = [
      { label: "Semua", value: "0" },
      { label: "Reviewer SPMI", value: "2013" },
      { label: "Admin PT", value: "3" },
    ];

    return (
      <>
        <NoticeContentManagementSystem
          style={{ marginBottom: "0px", boxShadow: "none" }}
        >
          <strong style={{ fontSize: "18px" }}>
            Content Management System
          </strong>
          <p>Penambahan Informasi</p>
        </NoticeContentManagementSystem>
        <br />
        <Card style={{ padding: "2%" }}>
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  {this.props.match.params.id === undefined ? (
                    <h2>Tambah Konten</h2>
                  ) : (
                    <h2>Edit Konten</h2>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/*========================================== Form Add User ========================================== */}
          <Form
            className="needs-validation"
            onSubmit={this.handleSave}
            noValidate
          >
            {this.state.loadingForm === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <Form.Row>
                  <Form.Group as={Col} controlId="viewer">
                    <Form.Label>
                      Ditujukan Untuk <span className="text-danger"> *</span>
                    </Form.Label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={false}
                      autoFocus={false}
                      options={roles}
                      placeholder="Pilih Role"
                      onChange={this.selectedRole}
                      defaultValue={{
                        label:
                          this.state.id_viewer === null
                            ? "-- Pilih Satu --"
                            : this.state.id_viewer === 0
                            ? "Semua"
                            : this.state.id_viewer === 3
                            ? "Admin PT"
                            : "Reviewer SPMI",
                      }}
                      required
                    />
                    <div className="invalid-feedback">
                      {this.state.errors.id_viewer}
                    </div>
                  </Form.Group>
                </Form.Row>

                {/* For turning off auto complete */}
                <input type="hidden" value="something" />
                <Form.Row>
                  <Form.Group as={Col} controlId="judul_konten">
                    <Form.Label>
                      Judul <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Judul Konten"
                      value={this.state.judul_konten}
                      onChange={(e) => this.onInputForm(e, "judul_konten")}
                      required
                    />
                    <div className="invalid-feedback">
                      {this.state.errors.judul_konten}
                    </div>
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} controlId="deskripsi">
                    <Form.Label>
                      Deskripsi <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Deskripsi singkat"
                      value={this.state.deskripsi}
                      onChange={(e) => this.onInputForm(e, "deskripsi")}
                      required
                    />
                    <div className="invalid-feedback">
                      {this.state.errors.deskripsi}
                    </div>
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col}>
                    <Form.Label>Gambar Sampul</Form.Label>
                    <div className="custom-file">
                      <Form.Control
                        type="file"
                        className="custom-file-input"
                        id="cover_pict"
                        onChange={(e) => this.handleUploadCoverPict(e)}
                      />
                      <label className="custom-file-label" for="cover_pict">
                        {this.state.cover_pict_name}
                      </label>
                    </div>
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} controlId="konten">
                    <Form.Label>
                      Konten <span className="text-danger"> *</span>
                    </Form.Label>
                    <ReactQuill
                      theme="snow"
                      onChange={this.handleChange}
                      value={this.state.konten}
                      modules={ContentManagementSystem.modules}
                      formats={ContentManagementSystem.formats}
                      bounds={".app"}
                      placeholder="Silahkan buat konten Anda..."
                      style={{
                        height: "320px",
                        maxHeight: "auto",
                        width: "auto",
                      }}
                    />
                    <div className="invalid-feedback">
                      {this.state.errors.konten}
                    </div>
                  </Form.Group>
                </Form.Row>

                {/* <Form.Row>
                  <Form.Group as={Col} controlId="lampiran">
                    <Form.Label>Lampiran Dokumen</Form.Label>
                    <div className="custom-file">
                      <Form.Control
                        type="file"
                        multiple
                        className="custom-file-input"
                        id="customFile"
                        onChange={(e) => this.handleUploadFiles(e)}
                      />
                      <label className="custom-file-label" for="customFile">
                        {this.state.file_name}
                      </label>
                    </div>
                  </Form.Group>
                </Form.Row> */}

                <Form.Row className="mt-16">
                  <Form.Group as={Col}>
                    <Form.Label>Lampiran Dokumen</Form.Label>
                    <div className="custom-file">
                      <Form.Control
                        type="file"
                        className="custom-file-input"
                        id="customFile"
                        onChange={(e) => this.handleUploadFiles(e)}
                      />
                      <label className="custom-file-label" for="customFile">
                        {this.state.file_name}
                      </label>
                    </div>
                  </Form.Group>
                </Form.Row>

                <div className="row">
                  <div className="col-md-12">
                    <div style={{ float: "right", marginLeft: "10px" }}>
                      <ButtonToolbar>
                        <span className="svg-icon svg-icon-2x svg-icon-white">
                          <Button
                            disabled={this.state.loadingBtn}
                            variant="primary"
                            type="submit"
                          >
                            Simpan
                            {this.state.loadingBtn && (
                              <i className="ml-2 mr-1 spinner spinner-white"></i>
                            )}
                            &nbsp;&nbsp;
                          </Button>
                        </span>
                      </ButtonToolbar>
                    </div>
                    <div style={{ float: "right" }}>
                      <ButtonToolbar>
                        <span className="svg-icon svg-icon-2x svg-icon-white">
                          <Link to="/content-management-system">
                            <Button
                              variant="secondary"
                              disabled={this.state.loadingBtn}
                            >
                              Kembali
                            </Button>
                          </Link>
                        </span>
                      </ButtonToolbar>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Form>
          {/*========================================== End Form ========================================== */}
        </Card>
      </>
    );
  }
}

ContentManagementSystem.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
ContentManagementSystem.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

export default ContentManagementSystem;
